import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import Flag from '@atlaskit/flag';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';

import { getCompareBranchesDialogSlice } from 'src/redux/branches';
import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './compare-branches-timeout-flag.i18n';

type Props = {
  id: ComponentFlagId;
} & HandleDismissedType;

export const CompareBranchesTimeoutFlag = ({ id, ...otherProps }: Props) => {
  const intl = useIntl();
  const { isMerge } = useSelector(getCompareBranchesDialogSlice);
  const action = isMerge ? 'merge' : 'sync';
  return (
    <Flag
      {...otherProps}
      id={id}
      icon={
        <StatusInformationIcon
          spacing="spacious"
          label="info"
          color={token('color.icon.discovery')}
        />
      }
      title={intl.formatMessage(messages[action].compareBranchesTimeoutTitle)}
      description={
        <FormattedMessage
          {...messages[action].compareBranchesTimeoutDescription}
        />
      }
    />
  );
};
